/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Success_ToastInputs */

const en_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes have been pasted successfully`)
};

const fr_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributs colles avec succes`)
};

const de_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute wurden erfolgreich eingefügt.`)
};

const it_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli attributi sono stati incollati correttamente`)
};

const ru_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Атрибуты успешно вставлены.`)
};

const es_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los atributos se han pegado correctamente`)
};

const zh_cn2_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性已成功粘贴`)
};

const ja_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性が正常に貼り付けられました`)
};

const hi_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताएँ सफलतापूर्वक पेस्ट कर दी गई हैं`)
};

const pt_pt2_paste_attributes_success_toast = /** @type {(inputs: Paste_Attributes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os atributos foram colados com sucesso.`)
};

/**
* | output |
* | --- |
* | "Attributes have been pasted successfully" |
*
* @param {Paste_Attributes_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_success_toast = /** @type {((inputs?: Paste_Attributes_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_success_toast(inputs)
	if (locale === "de") return de_paste_attributes_success_toast(inputs)
	if (locale === "it") return it_paste_attributes_success_toast(inputs)
	if (locale === "ru") return ru_paste_attributes_success_toast(inputs)
	if (locale === "es") return es_paste_attributes_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_success_toast(inputs)
	if (locale === "ja") return ja_paste_attributes_success_toast(inputs)
	if (locale === "hi") return hi_paste_attributes_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_success_toast(inputs)
	return en_paste_attributes_success_toast(inputs)
});